<template>
  <div class="tab-pane-content mt-5 width-100">
    <div class="row" v-if="userUpdate.validated_seller !== 1">
      <div
        v-if="userUpdate.rc === undefined || userUpdate.rc === null"
        class="col-8 offset-2 text-center alert alert-info"
      >
        {{ $t("sentence.toBecomeAXPleaseFillUpTheInfo", { subject: $t("attr.professional") }) }}
      </div>
      <div
        v-if="userUpdate.rc !== undefined && userUpdate.rc !== null"
        class="col-8 offset-2 text-center alert alert-info"
      >
        {{ $t("sentence.yourRequestIsInProgressYouWillReceiveAnEmailSoon") }}
      </div>
    </div>
    <form method="post" id="updateUser" @submit.prevent="updateUser">
      <div class="form-group mb-4">
        <div class="col-lg-12">
          <label for="address">{{ $t("attr.address") }}</label>
          <input
            type="text"
            :class="'form-control ' + { 'is-invalid': has_error && errors.address }"
            id="address"
            v-model="userUpdate.address"
          />
          <span class="help-block text-danger" v-if="has_error && errors.address">
            {{ errors.address[0] }}
          </span>
        </div>
      </div>

      <AddressSelector :errors="errors" :has_error="has_error" />

      <div class="form-group mb-4">
        <div class="col-lg-12">
          <label for="postal_code">{{ $t("attr.postal_code") }}</label>
          <input
            type="text"
            :class="'form-control ' + { 'is-invalid': has_error && errors.postal_code }"
            id="postal_code"
            v-model="userUpdate.postal_code"
          />
          <span class="help-block text-danger" v-if="has_error && errors.postal_code">
            {{ errors.postal_code[0] }}
          </span>
        </div>
      </div>
      <div class="form-group row mb-6">
        <div class="col-lg-12">
          <label for="rc" class="col-sm-4 col-lg-2 col-form-label">
            {{ $t("ecommerce.rc") }}
          </label>
          <div class="col-sm-8 col-lg-10">
            <div class="custom-file mb-1">
              <input
                type="file"
                class="custom-file-input"
                id="rc"
                name="rc"
                ref="rc"
                @change="onRcChange"
              />
              <label class="custom-file-label" for="rc">
                {{ $t("action.chooseFile") }}...
              </label>
              <span class="help-block text-danger" v-if="has_error && errors.rc">
                {{ errors.rc[0] }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          rcOverview !== false ||
          (userUpdate.rc !== undefined &&
            userUpdate.rc !== null &&
            typeof userUpdate.rc === 'string' &&
            userUpdate.rc.length > 0)
        "
        class="form-group row mb-6"
      >
        <div class="col-8">
          <div class="custom-file mb-1">
            <img
              :src="rcOverview !== false ? rcOverview : storageUrl + userUpdate.rc"
              class="thumbnail"
            />
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center justify-content-md-end mt-5">
        <button type="submit" class="btn btn-primary mb-2 btn-pill">
          {{ $t("action.confirm") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import config from "@/config";
import AddressSelector from "@/components/templates/AddressSelector";

export default {
  components: {
    AddressSelector,
  },
  data() {
    return {
      userUpdate: {},
      has_error: false,
      errors: {},
      rcOverview: false,
      storageUrl: config.storageUrl,
    };
  },
  mounted() {
    this.userUpdate = Object.assign({}, this.user);
    delete this.userUpdate.rc;
  },
  methods: {
    onRcChange() {
      this.userUpdate.rc = this.$refs.rc.files[0];
      this.rcOverview = URL.createObjectURL(this.userUpdate.rc);
    },
    updateUser() {
      var self = this;
      var formData = new FormData();
      window.scrollTo(0, 0);

      formData.append("address", self.userUpdate.address || "");
      formData.append("city", self.userUpdate.city || "");
      formData.append("postal_code", self.userUpdate.postal_code || "");

      if (self.userUpdate.rc !== undefined && self.userUpdate.rc !== null) {
        formData.append("rc", self.userUpdate.rc);
      }

      if (self.userUpdate.commune !== undefined && self.userUpdate.commune !== null) {
        formData.append("commune", self.userUpdate.commune);
      }

      this.$axios({
        url: "user/update/" + self.user.id,
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          if (response.data && response.data.data) {
            self.$store.commit("setUser", { user: response.data.data });
          } else {
            const updatedUser = Object.assign({}, self.user, self.userUpdate);
            self.$store.commit("setUser", { user: updatedUser });
          }

          self.has_error = false;
          self.errors = {};

          self.$notify({
            group: "success",
            title: "Bravo !",
            type: "success",
            text: "Profil modifié avec succès!",
          });
        })
        .catch((err) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          self.$notify({
            group: "error",
            title: "Erreur !",
            type: "error",
            text: "Une erreur est survenue !",
          });
          self.has_error = true;
          self.errors = err.response.data.data || {};
        });
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>